import styled, { css } from 'styled-components'
import { Spacing, Colors, Typography } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'
import Icon, { Icon20 } from 'builder/components/Icon'

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 544px;
  border-radius: ${Spacing.S};
  background-color: ${Colors.White};

  ${Media.Phone`
    width: 343px;
    border-radius: 12px;
  `}
`

export const CloseIconWrapper = styled.div<{ showHoverState: boolean }>(({ showHoverState }) => {
  return css`
    ${showHoverState
      ? ''
      : `& svg {
          &:hover {
            background: ${Colors.White};
            fill: ${Colors.Neutral70};
            cursor: default;
          }
        }`}
  `
})

export const CloseIcon = styled(Icon.AddSmall)`
  fill: ${Colors.Neutral70};
  background: ${Colors.White};
  border-radius: 50%;
  position: absolute;
  left: 484px;
  top: 32px;
  height: 28px;
  width: 28px;
  cursor: pointer;
  transform: rotate(225deg);

  &:hover {
    background: ${Colors.Blue50};
    fill: ${Colors.White};
  }

  ${Media.Phone`
    height: 24px;
    width: 24px;
    left: 299px;
    top: 20px;
    z-index: 2;
  `}
`

export const Visual = styled.img`
  border-radius: 16px 16px 0 0;
  width: 544px;
  height: 300px;
  ${Media.Phone`
    width: 343px;
    height: 188px;
    border-radius: 12px 12px 0 0;
  `}
`

export const Content = styled.div`
  padding: 32px;
  flex-grow: 1;

  ${Media.Phone`
    padding: 20px;
  `}
`

export const Title = styled.p`
  ${Typography.sizes.S};
  font-weight: ${Typography.weights.demibold};
  margin-bottom: 12px;

  ${Media.Phone`
    margin-bottom: 8px;
  `}
`

export const Text = styled.p`
  color: ${Colors.Neutral50};
  font-size: 19px;
  font-weight: 400;
  line-height: 24px;

  ${Media.Phone`
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
  `}
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0 ${Spacing.L} ${Spacing.L};
  gap: ${Spacing['2XS']};

  ${Media.Phone`
    flex-direction: row;
    padding: 0 20px 20px;
  `}
`

export const UnlockFeaturesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 ${Spacing.L} ${Spacing.L};
`

export const UnlockTitle = styled.p`
  ${Typography.sizes.Caps};
  font-weight: ${Typography.weights.demibold};
  color: ${Colors.Neutral80};
`

export const FeaturesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${Colors.Neutral5};
  padding: 16px;
  gap: 8px;
`

export const FeatureItem = styled.div`
  display: flex;
  gap: 4px;
`

export const FeatureIcon = styled(Icon20.Tick)`
  color: ${Colors.Green40};
`

export const FeatureText = styled.p`
  ${Typography.sizes.Caption};
  color: ${Colors.Neutral80};
`
